import React, {Component} from "react"
import {Container, Header, Icon} from "semantic-ui-react";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, interpolateString, parseMultilineString} from "../utils/localization";
import {setPrevRoute} from "../actions/appHeaderActions";
import {setSkipRecommendation} from "../actions/userActions";
import Footer from "./footer";
import {checkIsVerified, getBenAdminGreetingName, isRenaissance, registerSkipRecommendation, SELECT_PLAN_ROUTE, uiFlowBenAdmin} from "../utils/common";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        user,
        name: user.firstName,
        benAdmin: benAdmin,
        initialData: initialData,
        lang: user.lang,
        ...ownProps
    }
};

class WouldYouMind extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
    }

    registerSkipRecommendationAction() {
        const {initialData: {token}, dispatch} = this.props;
        dispatch(setSkipRecommendation(true));
        registerSkipRecommendation(token);
    }

    render() {
        const localization = getLocalization(this.props.lang);
        const strings = localization.wouldYouMind;
        const {uiFlow} = this.props.initialData;
        const isBenAdmin = uiFlow === uiFlowBenAdmin;
        const showSkipRecommendation = isRenaissance();
        const name = isBenAdmin ? getBenAdminGreetingName(this.props.benAdmin, this.props.initialData.distributionChannel) : this.props.name;
        return (
            <React.Fragment>
                <Container>
                    <CustomGrid container stackable columns={1} textAlign={'center'} style={{margin: '5em'}}>
                        <CustomGrid.Row>
                            <CustomGrid.Column>
                                <S3Image {...IMAGE.LEVERS} style={{ marginTop: '77px', marginBottom: '41px'}}/>
                                <Header as='h2'>{interpolateString(strings.title, [name])}</Header>
                                <p>{parseMultilineString(strings.subTitle)}</p>
                                <br/>
                                {showSkipRecommendation &&
                                    <p>
                                        {strings.iDontWant}
                                        <span>{' '}
                                            <Link to={SELECT_PLAN_ROUTE} onClick={() => this.registerSkipRecommendationAction()}>
                                                <span>{strings.skip}<Icon name="long arrow alternate right"/></span>
                                            </Link>
                                        </span>
                                    </p>
                                }
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(WouldYouMind));
